/* eslint-disable vue/no-multi-spaces */
<template>
  <v-speed-dial v-model="fab" bottom direction="top" fixed right style="z-index: 5;"
                transition="slide-y-reverse-transition" @click="keepOpen"
  >
    <template v-slot:activator>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn v-model="fab" class="ma-0 mt-1" color="blue darken-1" dark fab v-on="on">
            <v-icon>mdi-plus-circle-multiple-outline</v-icon>
            <v-icon>close</v-icon>
          </v-btn>
        </template>
        <span v-if="fab">
          Contraer Acciones
        </span>
        <span v-else>
          Expandir Acciones
        </span>
      </v-tooltip>
    </template>

    <template v-if="isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="primary" dark fab small v-on="on" @click="showIncidencia">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Incidencia Rápida</span>
      </v-tooltip>
    </template>

    <template v-if="pentiente && isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="deep-orange darken-1" dark fab small
                 v-on="on" @click="showTransfer(null, actions.transfer)"
          >
            <v-icon>mdi-forward</v-icon>
          </v-btn>
        </template>
        <span>Traspasar</span>
      </v-tooltip>
    </template>

    <template v-if="pentiente && estado !== 'U' && isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="light-green accent-3" fab light small
                 v-on="on" @click="showTransfer(0, actions.update)"
          >
            <v-icon>mdi-progress-upload</v-icon>
          </v-btn>
        </template>
        <span>Solicitar actualización</span>
      </v-tooltip>
    </template>

    <template v-if="estado === 'U' && isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="green darken-1 accent-3" fab light small
                 v-on="on" @click="showTransfer(tecnicoAsignado, actions.updateReleased)"
          >
            <v-icon>mdi-progress-download</v-icon>
          </v-btn>
        </template>
        <span>Actualización liberada</span>
      </v-tooltip>
    </template>

    <template v-if="pentiente">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="red darken-1" dark fab small v-on="on"
                 @click="showTransfer(tecnicoAsignado, actions.annular)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Anular</span>
      </v-tooltip>
    </template>

    <template v-if="estado === 'A' || estado === 'C'">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="deep-purple darken-1" dark fab small v-on="on" @click="showTransfer(tecnicoAsignado, actions.reOpen)">
            <v-icon>mdi-lock-open-outline</v-icon>
          </v-btn>
        </template>
        <span>Reabrir</span>
      </v-tooltip>
    </template>

    <template v-if="pentiente && isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="brown darken-1" dark fab small
                 v-on="on" @click="anclarIncidencia"
          >
            <v-icon>{{ anclaFechaInner ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
          </v-btn>
        </template>
        <span>{{ anclaFechaInner ? 'Desanclar' : 'Anclar' }}</span>
      </v-tooltip>
    </template>

    <template v-if="incidencia && isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="yellow darken-1" fab light small
                 v-on="on" @click="seguirIncidencia"
          >
            <v-icon>{{ seguimientoFechaInner ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
          </v-btn>
        </template>
        <span>
          {{ seguimientoFechaInner ? 'Desmarcar como seguimiento' : 'Marcar como seguimiento' }}
        </span>
      </v-tooltip>
    </template>

    <template v-if="incidencia && isTecnico">
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn color="blue" fab light small
                 :disabled="sendingEmail" v-on="on" @click="sendEmailClient"
          >
            <v-icon>{{ 'mdi-email' }}</v-icon>
          </v-btn>
        </template>
        <span>
          {{ 'Enviar E-mail a las personas de contacto' }}
        </span>
      </v-tooltip>
    </template>

    <!-- <v-tooltip left>
        <v-btn v-on="on" v-if="pentiente"
        <template v-slot:activator="{ on }">
               fab dark small color="teal darken-1" @click="showTransfer(tecnicoAsignado, actions.comment)">
          <v-icon>mdi-message-text</v-icon>
        </v-btn>
        </template>
        <span>Añadir Comentario</span>
      </v-tooltip>-->

    <template :class="telefonos ? 'mt-2' : ''" />
    <template v-for="(item, index) in telefonos">
      <v-badge :key="index" overlap left color="green darken-3">
        <template v-slot:badge>
          <span dark small>
            {{ index + 1 }}
          </span>
        </template>
        <v-tooltip v-if-tecnico left>
          <template v-slot:activator="{ on }">
            <v-btn :href="`aocphone:0${item}`" class="mt-0" color="green" dark fab icon
                   small target="_parent" v-on="on" @click="sleepAskToLeave"
            >
              <v-icon dark>
                phone
              </v-icon>
            </v-btn>
          </template>
          <span>{{ item }}</span>
        </v-tooltip>
      </v-badge>
    </template>
  </v-speed-dial>
</template>

<script>
import incidenciaNew from '@/pages/incidencias/edit.vue'
import { EventBus } from '@/store/EventBus.js'
import Transfer from '@/pages/incidencias/transfer.vue'
import store from '@/store/index.js'

export default {
  props: {
    cliente: { type: [String, Number], default: '0' },
    instalacion: { type: [String, Number], default: '0' },
    incidencia: { type: [String, Number], default: '0' },
    tecnicoAsignado: { type: [String, Number], default: '0' },
    anclaFecha: { type: [String, Date], default: null },
    seguimientoFecha: { type: [String, Date], default: null },
    observaciones: { type: String, default: '' },
    estado: { type: String, default: '' },
    telefonos: { type: Array, default: () => [] }
  },
  data: () => ({
    profile: store.getters['getProfile'],
    isTecnico: false,
    fab: false,
    anclaFechaInner: false,
    seguimientoFechaInner: false,
    sendingEmail: false,
    actions: {
      transfer: {
        title: 'Traspasar incidencia',
        messageTo: 'Incidencia traspasada correctamente',
        estado: '',
        emitReload: false,
        postAction: { action: 'exit', toName: 'incidencias' }
      },
      update: {
        title: 'Solicitar actualización',
        messageTo: 'Solicitada actualización',
        estado: 'U',
        emitReload: false,
        postAction: { action: 'exit', toName: 'incidencias' }
      },
      annular: {
        title: 'Anular incidencia',
        messageTo: 'Incidencia anulada correctamente',
        tecnicoDisabled: true,
        estado: 'A',
        required: true,
        emitReload: true
      },
      reOpen: {
        title: 'Reabrir incidencia',
        messageTo: 'Incidencia reabierta correctamente',
        estado: 'P',
        required: true,
        emitReload: true
      },
      comment: {
        title: 'Añadir comentario',
        messageTo: 'Comentario añadido correctamente',
        tecnicoDisabled: true,
        estado: '',
        emitReload: false,
        required: true,
        postAction: { action: 'exit', toName: 'incidencias' }
      },
      updateReleased: {
        title: 'Actualización liberada',
        messageTo: 'Actualización liberada',
        estado: 'P',
        emitReload: false,
        postAction: { action: 'exit', toName: 'incidencias' }
      }
    }
  }),
  computed: {
    pentiente () {
      return (
        this.incidencia &&
        !(this.estado === 'A' || this.estado === 'C') &&
        this.estado
      )
    }
  },
  watch: {
    /* fab: function (value) {
      if (!value) { this.fab = true }
    }, */
    anclaFecha: function (value) {
      this.anclaFechaInner = value
    },
    seguimientoFecha: function (value) {
      this.seguimientoFechaInner = value
    }
  },
  mounted () {
    this.keepOpen()
    this.anclaFechaInner = this.anclaFecha
    this.seguimientoFechaInner = this.seguimientoFecha
    this.getRol()
  },
  methods: {
    getRol: function () {
      if (this.profile.Role === 'Tecnico') {
        this.isTecnico = true
      }
    },
    keepOpen () {
      this.$nextTick(() => {
        setTimeout(() => { this.fab = !this.$vuetify.breakpoint.smAndDown }, 50)
      })
    },
    showIncidencia () {
      this.keepOpen()
      EventBus.$emit('showModal', {
        component: incidenciaNew,
        props: { fullForm: false, emitReload: false }
      })
    },
    showTransfer (TecnicoAsignado, Accion) {
      this.keepOpen()
      EventBus.$emit('showModal', {
        component: Transfer,
        props: {
          componentProps: {
            TecnicoAsignado,
            Accion,
            Cliente: this.cliente,
            Instalacion: this.instalacion,
            Incidencia: this.incidencia,
            Observaciones: this.observaciones
          }
        }
      })
    },
    anclarIncidencia () {
      this.keepOpen()
      let anclar = `?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}`
      anclar += `&anclar=${!this.anclaFechaInner}`
      this.axios
        .get(this.$apiUrl('anclarIncidencia') + anclar, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(({ data }) => {
          if (data) {
            this.anclaFechaInner = data.AnclaFecha
            this.$notify({
              message: `Incidencia ${
                this.anclaFechaInner ? 'anclada' : 'desanclada'
              }.`,
              type: 'info'
            })
          }
        })
    },
    seguirIncidencia () {
      this.keepOpen()
      let seguir = `?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}`
      seguir += `&seguir=${!this.seguimientoFechaInner}`
      this.axios
        .get(this.$apiUrl('seguirIncidencia') + seguir, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(({ data }) => {
          if (data) {
            this.seguimientoFechaInner = data.SeguimientoFecha
            this.$notify({
              message: `Incidencia ${
                this.seguimientoFechaInner ? 'marcada' : 'desmarcada'
              } como seguimiento.`,
              type: 'info'
            })
          }
        })
    },
    sendEmailClient () {
      this.keepOpen()
      this.sendingEmail = true
      let url = `?cliente=${this.cliente}&instalacion=${this.instalacion}&incidencia=${this.incidencia}`
      this.axios
        .get(this.$apiUrl('enviarEmailContacto') + url, {
          headers: { 'Content-Type': 'application/json' }
        })
        .then(({ data }) => {
          if (data) {
            this.$notify({
              message: `Usuarios notificados correctamente`,
              type: 'info'
            })
            this.sendingEmail = false
          } else {
            this.sendingEmail = false
          }
        })
        .catch(() => {
          this.sendingEmail = false
        })
        .finally(() => {
          this.sendingEmail = false
        })
    },
    sleepAskToLeave () {
      this.keepOpen()
      let AskToLeave = this.$store.state.askToLeave
      this.$store.dispatch('AskToLeave', false)
      setTimeout(() => {
        this.$store.dispatch('AskToLeave', AskToLeave)
      }, 750)
    }
  }
}
</script>
